<template>
    <!-- DEPRECATED: USE OptionProduction.vue -->
    <div class="config-group-outline px-prj2 py-prj px-3@large border mt-prj3">
        <div class="row my-children-2">
            <div class="small-12 column">
                <div class="config-item__info d-inline-flex production-info">
                    <h2 class="h3 mt-0 mb-0">
                        {{this.group.caption}}
                    </h2>
                    <!-- abbr class="ml-2" rel="tooltip"
                          :title="'tooltipProductionInfo'|translate">
                        <InfoIcon classes='svg-icon icon-tooltip svg-icon--small@large'/>
                    </abbr -->
                </div>
                <div class="row my-children-2">
                    <div class="small-12 column">
                        <div v-if="auflageId != '0' && produktionsverfahren.values.length"
                             class="config-group-outline px-prj2 py-prj px-3@large border">
                            <template v-for="(optionValue, idx) in produktionsverfahren.values">

                                <div class="config-item__info d-inline-flex flex-column py-prj2 py-prj3@large w-100">
                                    <input type="radio" :name="produktionsverfahren.id" :value="optionValue.id"
                                           :id="optionValue.fullId" v-model="produktionVal">
                                    <label :for="optionValue.fullId" class="label-aligned font-weight-bold">
                                        <span class="mainlabel">{{optionValue.caption}}</span>
                                        <span class="font-weight-light font-italic d-block@until-large text-small@until-medium">{{versandTermine['produktionsdauer'+optionValue.id]}}</span>
                                        <span class="font-weight-light font-italic d-block@until-large text-small@until-medium">{{optionValue.text}}</span>
                                    </label>
                                    <ul v-if="produktionVal==optionValue.id" class="config-item__list r-list mt-1 ml-3">
                                        <li v-for="lieferartValue in lieferart.values"
                                            class="border-bottom py-prj2" v-if="isLieferartVisible(lieferartValue.id)">
                                            <input type="radio" :name="lieferart.id" :value="lieferartValue.id"
                                                   :id="lieferart.id+'_'+lieferartValue.id"
                                                   v-model="lieferartVal">
                                            <label :for="lieferart.id+'_'+lieferartValue.id"
                                                   class="label-aligned font-weight-bold">
                                                <span class="mainlabel">{{lieferartValue.caption}}</span>
                                                <span class="font-weight-light d-block@until-large text-small@until-medium">{{ getPorto( lieferartValue.id ) }}</span>
                                                <Tooltip v-if="lieferartValue.additionalValues.infoText" :infoText="lieferartValue.additionalValues.infoText"/>
                                            </label>
                                            <template v-if="isVersandaufteilung(lieferartValue.id) && isVersandaufteilung(lieferartVal)">
                                                <VersandaufteilungOverlay 
                                                    :isCheckout="false" 
                                                    :isSelected="isVersandaufteilung(lieferartVal)" 
                                                    :addresses="addresses" 
                                                    :auflage-zahl="individualAuflage"
                                                    :belegexemplar="belegexemplar"
                                                    :productImageUrl="globalConfig.productImageUrl"
                                                    :productName="globalConfig.product_name"
                                                >
                                                </VersandaufteilungOverlay>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                                <hr class="m-0 bg-shade" v-if="idx < produktionsverfahren.values.length-1"/>
                            </template>
                        </div>
                        <div v-else>
                            <div class="text-small mt-prj text-error d-flex line-height-12">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
                                {{'lblKeineAuflageGewaehlt'|translate}}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export const LIEFERART_OPTIONID = "lieferart";
    import {toStringKey} from 'classes/helpers';

    import {AUFLAGE_ZAHL} from "components/OptionGroupMain";
    import VersandaufteilungOverlay from 'components/versandaufteilung/VersandaufteilungOverlay.vue';
    import Tooltip from "components/Tooltip";
    import DeliveryOptionMixin from "mixins/deliveryOption.js";
    import {ADDITIONAL_VALUE_PRODUKTIONSDAUER_DATE, ADDITIONAL_VALUE_PRODUKTIONSDAUER} from 'mixins/deliveryOption.js'

    import {translatePrj} from "classes/vue-dict-filter.js"

    export default {
        components: {VersandaufteilungOverlay, Tooltip},
        name: "OptionGroupProduction.vue",
        props: ["group", "values", "auflagen", "individualAuflage", "addresses"],
        inject: ["optionsService", "globalConfig"],
        mixins:[ DeliveryOptionMixin ],
        data() {

            // for easier understanding the fancy ... was not use but would be perfectly possible:
            // return {
            //    ...this.filterOptions(),
            //     user: false
            // }

            const o = this.filterOptions();
            return {
                lieferart: o.lieferart,
                produktionsverfahren: o.produktionsverfahren,
                user: false,
                belegexemplar: this.values.belegexemplar || "0"
            }
        },
        methods: {
            filterOptionValues(option) {
                const filtered_options = option.values.filter(v => !this.optionsService.isExcludedByCurrentValues(v))

                filtered_options.forEach(v => {
                    v.fullId = toStringKey(option.id, v.id)
                });

                return {id: option.id, caption: option.caption, values: filtered_options}
            },
            filterOptions() {
                const o = this.optionsById()
                return {
                    produktionsverfahren: this.filterOptionValues(o.produktionsverfahren),
                    lieferart: this.filterOptionValues(o.lieferart)
                }
            },
            optionsById() {
                   return this.group.options.reduce((map,val) => {map[val.id] = val; return map}, {})
            },
            isVersandaufteilung(lieferartOptionId) {
                const selectedLief = this.lieferart.values.find(v => v.id == lieferartOptionId)
                return Boolean( selectedLief?.additionalValues?.versandaufteilung )
            },
            isSamstagszustellung( lieferartOptionId ) {
                const selectedLief = this.lieferart.values.find(v => v.id == lieferartOptionId)
                return Boolean( selectedLief?.additionalValues?.samstagszustellung )
            },
            allowedInContext( lieferartOptionId ) {
                const selectedLief = this.lieferart.values.find(v => v.id == lieferartOptionId)
                return Boolean( selectedLief?.additionalValues?.validContexts
                    .find(context => context === this.globalConfig.contextid ) )
            },
            isLieferartVisible( lieferartOptionId ) {
                return (!this.isSamstagszustellung(lieferartOptionId) || this.samstagszustellungPossible) &&
                    (this.allowedInContext(lieferartOptionId) )
            },
            checkSelectionVisible() {
                const prod = this.produktionsverfahren.values.find(v => v.id == this.produktionVal)
                if( !prod ) {
                    this.$emit("change", [this.produktionsverfahren.id, 0])
                }
                const lief = this.lieferart.values.find(v => v.id == this.lieferartVal)
                if( !lief || !this.isLieferartVisible(lief.id) ) {
                    const firstVisible = this.lieferart.values.find(v => this.isLieferartVisible(v.id))
                    if( firstVisible ) {
                        this.$emit("change", [this.lieferart.id, firstVisible.id])
                    } else {
                        this.$emit("change", [this.lieferart.id, 0])
                    }
                }
            },
            getPorto( lieferartValueId ) {
                let additionalValues = this.lieferart.values.find( v => v.id == lieferartValueId ).additionalValues;
                let porto = additionalValues['displayPrice'+this.globalConfig.contextid];
                return '(' + porto +')';
            }


        },
        computed: {
            produktionVal: {
                get() {
                    return this.values[ this.produktionsverfahren.id ]
                },
                set(val) {
                    this.$emit( "change", [ this.produktionsverfahren.id, val ] )
                }
            },
            lieferartVal: {
                get() {
                    return this.values[ this.lieferart.id ]
                },
                set(val) {
                    this.$emit( "change", [ this.lieferart.id, val ] )
                }
            },
            auflageId() {
                return this.values[AUFLAGE_ZAHL];
            },

            samstagszustellungPossible() {
                let auflage = this.auflagen.values.find( value => value.id == this.auflageId)
                let date = auflage.additionalValues[ADDITIONAL_VALUE_PRODUKTIONSDAUER_DATE + this.values["produktionsverfahren"]]
                return this.isSamstagszustellungAllowed(new Date( date ));
            },
            versandTermine() {
              const o = this.optionsById()
              return o.lieferart.dynamicValues.versandtermine || {};
            }
        },
        watch: {
            values: {
                handler() {
                    const o = this.filterOptions()
                    this.lieferart = o.lieferart
                    this.produktionsverfahren = o.produktionsverfahren
                    this.checkSelectionVisible()
                    this.belegexemplar = this.values.belegexemplar
                },
                deep: true
            }
        },
        mounted() {
            this.checkSelectionVisible()
        }
    }
</script>

<style scoped>

</style>